<!-- eslint-disable -->
<template>
  <div class="comp-md-kr-input-Group">
    <div
      v-for="(row, index) in data"
      :key="row.id"
      class="group-item"
    >
      <el-form-item
        ref="formItem"
        :error="err[index]"
      >
        <div class="group-box left-box">
          {{ index + 1 }}
        </div>
        <div class="group-box center-box">
          <el-input
            v-model="row.label"
            class="group-box-input box-input"
            placeholder="请输入二级菜单名称"
            @blur="inputBlur"
          />
          
          <el-select
            v-model="row.type"
            class="group-box-input box-select"
            placeholder="选择二级菜单类型"
            @change="selectTypeChange"
          >
            <el-option
              v-for="option in getSecOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>

          <el-select
            v-if="[2,8,9].includes(row.type)"
            v-model="row.targetValue"
            class="group-sec-box-input box-select"
            placeholder="请选择"
            @change="selectChange"
          >
            <el-option
              v-for="option in options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>

          <el-input
            v-if="row.type== 7"
            v-model="row.urlHref"
            class="group-sec-box-input box-input"
            placeholder="请输入URL"
            @blur="inputBlur"
          />
        </div>
        <div class="group-box right-box">
          <i
            class="el-icon-circle-plus"
            @click="handelAddButton(index)"
          />
          <i
            class="el-icon-remove remove-button"
            @click="handelRemoveButton(index)"
          />
        </div>

        <div class="group-box row" v-if="row.type === 2 && ![null, undefined, ''].includes(row.targetValue)">
          <ConditionRow :apiName="row.targetValue" @updateData="handleUpdateRowData(index, $event)" ref="condition"/>
        </div>
      </el-form-item>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { describeComponent } from '@inv/services/metaData/businessCustomization';
import filterOptionsByAuth from '@inv/view/metaData/settings/businessCustomization/tabManage/filterOptionsByAuth.js';
import { insightMenu } from '@/view/createTab/insightMenu';
import ConditionRow from './ConditionRow';
import { labMenu } from '@/view/createTab/labMenu';

export default {
  props: {
    value: kr.vue.getPropArray()
  },
  data() {
    return {
      options: [],
      moduleOptions: [],
      data: [],
      baseData: [],
      err: {},
      timer: '',
      secOptions: [
        { value: 8, label: '鲸准数据' },
        { value: 9, label: '鲸准实验室' },
        { value: 2, label: '业务对象' },
        { value: 3, label: '统计分析' },
        { value: 4, label: '报告管理' },
        { value: 5, label: '文件库' },
        { value: 6, label: '工作进展' },
        { value: 7, label: 'URL' },
        { value: 10, label: '项目库' },
      ]
    }
  },
  components: {
    ConditionRow,
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.data = val.map((item) => {
          return Object.assign({}, item)
        });
      }
    }
  },
  computed: {
    biAuth() {
      return this.$store.getters['auth/getAuth'](this, 'bi');
    },
    file_libary() {
      return this.$store.getters['auth/getAuth'](this, 'file_libary');
    },
    work_process() {
      return this.$store.getters['auth/getAuth'](this, 'work_process');
    },
    getSecOptions() {
      let { secOptions } = this;
      return this.filterOptionsByAuth(secOptions);

      // let { secOptions, biAuth, file_libary, work_process } = this;

      // if (!biAuth) {
      //   secOptions = secOptions.filter(i => i.value !== 4);
      // }
      // if (!file_libary) {
      //   secOptions = secOptions.filter(i => i.value !== 5);
      // }
      // if (!work_process) {
      //   secOptions = secOptions.filter(i => i.value !== 6);
      // }
      // return secOptions;
    },
  },
  methods: {
    filterOptionsByAuth,
    setErr(err) {
      this.err = err;
      this.timer = setTimeout(() => {
        this.err = {};
      }, 3000);
    },
    getFormItem() {
      return this.$refs.formItem;
    },
    inputBlur() {
      this.$emit('input', this.data);
    },
    selectTypeChange(data){
      if(data == 2){  //如果是业务对象
        this.options = this.moduleOptions
      }else if(data == 8){
        this.options = insightMenu.map((ii)=>{ return {label: ii.title, value: ii.key} })
      }else if(data == 9){
        this.options = labMenu.map((ii)=>{ return {label: ii.title, value: ii.key} })
      }
      this.$emit('input', this.data);
    },
    selectChange() {
      this.$emit('input', this.data);
    },
    handelAddButton(index) {
      let item = Object.assign({}, this.baseData);
      item.id = kr.getId(16);
      this.data.splice(index + 1, 0, item);
      this.$emit('input', this.data);
    },
    handelRemoveButton(index) {
      if (this.data.length === 1) {
        this.$confirm('请至少添加一条二级菜单', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {});
        return;
      }
      this.data.splice(index, 1);
      this.$emit('input', this.data);
    },
    async querySelectOptions() {
      const res = await describeComponent();
      this.moduleOptions = res;
      this.options = res;
    },
    handleSubmit() {
      this.$refs.condition[0].handleGetValue()
    },
    handleUpdateRowData(rowIndex, [key, value]) {
      this.data = this.data.map((i, idx) => {
        return idx === rowIndex
          ? {
            ...i,
            [key]: value,
          }
          : i
      })
      
      this.$emit('input', this.data)
    }
  },
  created() {
    this.value[0].id = kr.getId(16);
    this.baseData = Object.assign({}, this.value[0]);
    this.querySelectOptions();
  }
}
</script>

<style lang="scss">

  .comp-md-kr-input-Group {
    .group-item {
      position: relative;
      font-size: 0;
    }

    .group-box {
      /* display: inline-block; */
      .group-box-input {
        width: 50% !important;
      }

      .group-sec-box-input {
        display: block;
        width: 100%;
        padding-right: 0 !important;
        padding-left: 0 !important;
      }

      .box-input {
        padding-right: 5px;
      }

      .box-select {
        padding-left: 5px;
      }
    }

    .left-box {
      position: absolute;
      width: 20px;
      height: 20px;
      background: #f6f7fb;
      border-radius: 2px;
      font-size: 13px;
      color: #525975;
      text-align: center;
      line-height: 20px;
      margin-top: 10px;
    }

    .center-box {
      margin-left: 30px;
      margin-right: 60px;
      font-size: 0;
    }

    .right-box {
      position: absolute;
      color: #cacee0;
      top: 0;
      right: 0;
      font-size: 22px;
    }
  }

</style>
